import { useStateManager } from "@bcm-dev/bcms-vite";
import { TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView } from "components/shared";
import { TableBody } from "components/shared/views/TableView";
import { UICheckbox } from "components/ui";
import React from "react";

import "./styles.css";

/**
 * @function FastBalancesAccountTable
 * @return {React.Component}
 * @exported true
 * @description The main component for FastBalancesAccountTable
 */
export default function FastBalancesAccountTable(props) {
    const accounts = props.accounts ?? [];
    const rows = accounts.reduce((acc, account) => {
        acc.push(<FastBalancesDevicesRow key={ account.id } account={ account } />);
        return acc;
    }, []);
    return (
        <TableView className="fast-balances-account-table">
            <TableColumnContainer>
                <TableColumnView className="text-left" />
                <TableColumnView className="text-left" text="Account" />
            </TableColumnContainer>
            <TableBody>
                { rows }
            </TableBody>
        </TableView>
    )
}

/**
 * @function FastBalancesDevicesRow
 * @return {React.Component}
 * @param {STRING} accountNumber - The last four numbers of the account. 
 * @param {STRING} accountName - The name of the account.
 * @param {FUNCTION} onClick - Allows the user to click the checkbox.
 * @exported true
 * @description This is the table row to show account name and number inside the FastBalancesAccountTable component.
 */
function FastBalancesDevicesRow(props) {
    const { onAccountUpdate } = useStateManager();
    const account = props.account ?? {};
    return (
        <TableItemContainer>
            <UICheckbox label="" onChange={ onAccountUpdate(account, "hasFastBalances") } value={ account.hasFastBalance } dataPoint={ `Account_Checkbox_${ account.id }` } />
            <TableItemTextView text={ account.name + " " + account.number } dataPoint={ `Account_Name_${ account.id }` } />
        </TableItemContainer>
    )
}